export default __webpack_public_path__ + "static/media/top_w992up_5.72048957.png";